import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

export type TagTone = 'default' | 'brand' | 'teal' | 'amber' | 'green' | 'red';

interface TagProps {
  tone?: TagTone;
  children: ReactNode;
  className?: string;
}

export function Tag({ tone = 'default', children, className }: TagProps) {
  return (
    <span className={cn('ds-tag', tone !== 'default' && tone, className)}>
      {children}
    </span>
  );
}

export function TagMore({ count, className }: { count: number; className?: string }) {
  return <span className={cn('ds-tag-more', className)}>+{count}</span>;
}

export function TagStack({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cn('ds-tag-stack', className)}>{children}</span>;
}
